module.exports = __webpack_public_path__ + "static/media/tour-prize-found.a24fa643.svg";